/* eslint-disable array-callback-return */
import React from 'react';
import { Row, Col, message, Layout, Button, Input, Select, Form, Icon } from 'antd';
import TableWrapper from "../elements/TableWrapper";
import img from '../../assets/img/Illustratiion.png';
import MiCompAPI from '../../util/api';
const { Content } = Layout;
const { Option } = Select;
class CommissionColumnMapping extends React.Component {

    constructor(props) {
        super(props);
        this.columns = [{
            title: 'Column',
            dataIndex: 'col_name',
            width: '30%'


        },
        {
            title: 'Required',
            dataIndex: 'isrequired',
            width: '20%',
            render: (text, record) => record['isrequired'] ? 'Yes' : 'No'

        },
        {
            title: 'Column Name',
            dataIndex: 'val',
            width: '50%',
            render: (text, record) => <fieldset style={{ height: '33px', margin: "-10px", width: "300px" }}>
                <Input style={{ paddingTop: '12px' }} className="mi_input" onChange={this.UserColChange.bind(this, record)} defaultValue={record['val']}></Input>
            </fieldset>



        }];
        this.state = {
            _columns: null,
            loading: false,
            ext: null,
            id: 0,
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);

    }
    UserColChange = (record, e) => {
        this.setState({
            _columns: this.state._columns.map(x => {
                if (x.id === record.id) {
                    return { ...x, val: e.target.value }
                }
                else {
                    return x
                }
            })
        })
    }
    componentDidMount = () => {

        this.GetMaster_Commission_Map();

    }
    Submitt = () => {
        if (!document
            .querySelector("#filename_convention")
            .value) {
            message.destroy();
            message.error("Filename Convention is Required", 4);
            return;
        }
        var input = [];
        this.state._columns.map(x => {
            input.push({ col_name: x.col_name, map_col_name: x.val })
        });
        var valid = this.state._columns.filter(x => x.isrequired && (x.val === "" || x.val === null));
        if (valid.length === 0) {
            var file = {
                id: this.state.id,
                client_id: this.props.client_id,
                file: document
                    .querySelector("#filename_convention")
                    .value,
                file_ext: this.state.ext,
                commissionMaps: input
            }
            this.SaveCommission_Col_Map(file);
        } else {
            message.destroy();
            message.error("Please provide required column values", 4);
        }
    }
    SaveCommission_Col_Map = (data) => {
        this.api.invoke(
            "SaveCommission_Col_Map",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        message.destroy();
                        message.success(data.statusMessage, 4);
                        this.GetMaster_Commission_Map();

                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 4);
                    }

                }
            },
            data
        );

    }
    GetMaster_Commission_Map = () => {
        this.setState({
            loading: true,
        })
        this.api.invoke(
            "GetMaster_Commission_Map/" + this.props.client_id,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        
                        this.setState({
                            _columns: data.data
                            , loading: false,
                            ext: data.data[0].ext ? data.data[0].ext : "xlxs",
                            id: data.data[0].mId
                        })

                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 4);
                    }


                }
            }
        );
    }
    changeState = (val) => {
        this.setState({
            ext: val,
        })
    }
    render() {


        return (
            <Content>
                <div className="mi_main_div">
                    {this.state._columns ?
                        <div className="mi_main" style={{marginLeft:'-20px',marginRight:"-20px",marginTop: "0px"}}>
                            <Form layout="vertical">
                                <Row span={24} >
                                    <Col span={7}>
                                    </Col>
                                    <Col span={10}>
                                        <Form.Item>
                                            <fieldset style={{ margin: '10px' }}>
                                                <legend style={{ marginLeft: '-10px' }}>File Type</legend>
                                                <Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                    onChange={this.changeState.bind(this)}
                                                    id="filen_type"
                                                    defaultValue={this.state._columns ? this.state._columns[0].ext : this.state.ext}
                                                    placeholder="Please Select">
                                                    <Option value="xls" key="xls">xls</Option>
                                                    <Option value="xlsx" key="xlsx">xlsx</Option>
                                                    <Option value="csv" key="csv">csv</Option>
                                                    <Option value="xml" key="xml">xml</Option>
                                                    <Option value="json" key="json">json</Option>
                                                </Select>
                                            </fieldset></Form.Item>
                                        <Form.Item>
                                            <fieldset style={{ margin: '10px' }}>
                                                <legend style={{ marginLeft: '-10px' }}>File Name Convention(ex:xyz_Commsission.xlsx)</legend>

                                                <Input id="filename_convention" placeholder="xyz_Commsission.xlsx" defaultValue={this.state._columns ? this.state._columns[0].filename : ""} autoComplete="off" className="ant-input mi_input" style={{ width: "80%" }} />{"." + this.state.ext}
                                            </fieldset></Form.Item>

                                    </Col>
                                    <Col span={7}>
                                    </Col>

                                </Row></Form></div> : ""}

                    <Row span={24} style={{marginLeft:'-20px',marginRight:"-20px"}}>
                        <Col span={24}>
                            <TableWrapper rowKey="id" title="Commission Mapping"
                                bordered={true} columns={this.columns} data={this.state.loading ? null : this.state._columns} loading={this.state.loading}

                            />
                        </Col>

                    </Row>
                    <Row span={24} style={{ marginTop: '20px' }}>
                        <Col span={7} ></Col>
                        <Col span={3} >



                        </Col>
                        <Col span={5} >

                            <Button onClick={this.Submitt} type="primary">
                                Submit
                            </Button>

                        </Col>
                        <Col span={2} >

                        </Col>
                        <Col span={7} >
                            <img alt="example" style={{ width: 105, marginBottom: '-20px', float: 'right' }} src={img} />
                        </Col>
                    </Row>
                </div>
            </Content>
        );
    }
}
export default CommissionColumnMapping;
